import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { DECK_ASSET_URLS } from "./deckQueEs";

/**
 * Export del deck (Materiales). A diferencia del flyer (documento vertical de
 * email), el deck son slides fijos 1920×1080: se renderiza el HTML en modo
 * "export" (slides apilados, sin script) en un iframe off-screen y se captura
 * cada slide por separado con html2canvas.
 */
const SLIDE_W = 1920;
const SLIDE_H = 1080;

async function renderSlideCanvases(html) {
  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, {
    position: "fixed", left: "-100000px", top: "0", width: `${SLIDE_W}px`, height: `${SLIDE_H}px`, border: "0", background: "#ffffff",
  });
  iframe.setAttribute("aria-hidden", "true");
  document.body.appendChild(iframe);
  try {
    const doc = iframe.contentDocument;
    doc.open(); doc.write(html); doc.close();
    // Esperar fuentes e imágenes antes de capturar.
    try { await doc.fonts.ready; } catch (_) {}
    await Promise.all(
      Array.from(doc.images).map((img) => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()))
    );
    await new Promise((r) => setTimeout(r, 250));
    const slides = Array.from(doc.querySelectorAll(".slide"));
    iframe.style.height = `${slides.length * SLIDE_H}px`;
    const canvases = [];
    for (const el of slides) {
      canvases.push(await html2canvas(el, {
        scale: 2, backgroundColor: "#ffffff", useCORS: true, windowWidth: SLIDE_W, width: SLIDE_W, height: SLIDE_H,
      }));
    }
    return canvases;
  } finally {
    document.body.removeChild(iframe);
  }
}

/** PDF apaisado, una página por slide. */
export async function descargarDeckPdf(html, filename) {
  const canvases = await renderSlideCanvases(html);
  const pdf = new jsPDF({ unit: "px", format: [SLIDE_W, SLIDE_H], orientation: "landscape", hotfixes: ["px_scaling"] });
  canvases.forEach((canvas, i) => {
    if (i > 0) pdf.addPage([SLIDE_W, SLIDE_H], "landscape");
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, SLIDE_W, SLIDE_H);
  });
  pdf.save(filename);
}

/** Un PNG por slide (basename-slide-1.png, -2, -3). */
export async function descargarDeckPngs(html, basename) {
  const canvases = await renderSlideCanvases(html);
  for (let i = 0; i < canvases.length; i++) {
    const a = document.createElement("a");
    a.href = canvases[i].toDataURL("image/png");
    a.download = `${basename}-slide-${i + 1}.png`;
    document.body.appendChild(a); a.click(); a.remove();
    // Safari/Chrome descartan descargas disparadas demasiado juntas.
    await new Promise((r) => setTimeout(r, 400));
  }
}

async function toDataUri(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`No se pudo leer ${url}`);
  const blob = await res.blob();
  return await new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.onerror = reject;
    fr.readAsDataURL(blob);
  });
}

/**
 * Reemplaza las URLs de assets del bundle (imágenes y fuentes) por data-URIs
 * para que el HTML descargado sea autocontenido (funciona sin conexión y
 * fuera de la app).
 */
export async function inlineDeckAssets(html) {
  let out = html;
  for (const url of DECK_ASSET_URLS) {
    if (!out.includes(url)) continue;
    try {
      const dataUri = await toDataUri(url);
      out = out.split(url).join(dataUri);
    } catch (_) {
      // Si un asset no se puede leer, el HTML queda con la URL original.
    }
  }
  return out;
}
